<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <div>
          <div>
            <img src="@/assets/images/pw-alert.svg" alt="" />
          </div>
          <span v-html="message" class="text"/>
        </div>
      </div>
      <div class="button-wrap">
        <button class="button-bg-gray border-left-round" @click="noEvent()">{{ confirmPopupNoButton }}</button>
        <button class="button-bg-yellow border-right-round" @click="yesEvent()">{{ confirmPopupYesButton }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import BottomButton from '@/components/common/BottomButton.vue';
export default {
  name: 'passwordConfirmPopup',
  props: ['message', 'confirmPopupNoButton', 'confirmPopupYesButton'],
  components: { BottomButton },
  data() {
    return {};
  },
  methods: {
    noEvent() {
      //아니오 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickNo', 'no');
    },
    yesEvent() {
      //예 버튼 눌렀을때 이벤트
      this.$emit('confirmPopupClickYes', 'yes');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/pages/cards/pwSetupPopup.scss';
</style>
